var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select2',_vm._b({staticClass:"select2-selection__rendered",staticStyle:{"width":"auto"},attrs:{"options":_vm.options},on:{"change":_vm.changeValue},model:{value:(_vm.select2Value),callback:function ($$v) {_vm.select2Value=$$v},expression:"select2Value"}},'Select2',_vm.$attrs,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abc9fc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/selector/enums/selectorEnums.vue
// module id = null
// module chunks = 